<div class="grid-1col input-grid-gaps">
    <app-text-input [form]="form" id="name" [prefix]="translatePrefix"></app-text-input>
    <app-text-input [form]="form" id="code" [prefix]="translatePrefix"></app-text-input>
    <app-switch-input [form]="form" id="isDefault" [prefix]="translatePrefix"></app-switch-input>
</div>
